function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { keys, omit } from 'lodash-es';
import { FilterPickerGroup } from 'seagull';
import { useTableListContext } from 'seagull/components/TableList/TableList.utils';
import AddFilter from "../AddFilter/AddFilter";
import Filter from "../Filter/Filter";
import { isInitialFilterValue, makeInitialFilterValue } from "./TableFilters.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TableFilters = _ref => {
  let {
    testIdPrefix,
    filterLabels,
    filterConfig,
    selectedFilters,
    onRefresh,
    setSelectedFilters
  } = _ref;
  const {
    sort
  } = useTableListContext();
  const _onChange = (filter, value) => {
    const newSelectedFilters = _objectSpread(_objectSpread({}, selectedFilters), {}, {
      [filter]: value
    });
    onRefresh(newSelectedFilters, sort);
    setSelectedFilters(newSelectedFilters);
  };
  const _onRemove = filterToRemove => {
    const selectedFilterValue = selectedFilters[filterToRemove];
    const newSelectedFilters = omit(selectedFilters, filterToRemove);
    if (!isInitialFilterValue(selectedFilterValue, filterConfig[filterToRemove])) onRefresh(newSelectedFilters, sort);
    setSelectedFilters(newSelectedFilters);
  };
  const onSelect = filter => {
    setSelectedFilters(_objectSpread(_objectSpread({}, selectedFilters), {}, {
      [filter]: makeInitialFilterValue(filterConfig[filter])
    }));
  };
  return /*#__PURE__*/_jsxs(FilterPickerGroup, {
    flexWrap: true,
    "data-testid": "".concat(testIdPrefix, "-filters"),
    children: [keys(selectedFilters).map(filter => /*#__PURE__*/_jsx(Filter, {
      label: filterLabels[filter],
      filter: filter,
      selectedFilter: selectedFilters[filter],
      testIdPrefix: testIdPrefix,
      onChange: value => _onChange(filter, value),
      onRemove: () => _onRemove(filter),
      filterConfig: filterConfig[filter]
    }, filter)), keys(selectedFilters).length < keys(filterConfig).length && /*#__PURE__*/_jsx(AddFilter, {
      filtersMap: filterLabels,
      testId: testIdPrefix,
      selectedFilters: keys(selectedFilters),
      onSelect: onSelect
    })]
  });
};
export default TableFilters;